// Tasks
export * from "./tasks.component";
export * from "./tasks.service";


// WEBPACK FOOTER //
// ./src/app/modules/userHome/tasks/index.ts